import type { BlockManifest } from '@template-ui/blocks';
const originalSchedulingBlockManifests: BlockManifest[] = ['scheduling.hearing', 'scheduling.history'].map((code, index) => ({
  provider: 'scheduling', code, version: 1,
  name: index ? 'Scheduling history' : 'Hearing scheduling',
  description: index ? 'Request and booking changes for this hearing.' : 'Request scheduling, inspect the booking and open the calendar for this hearing.',
  category: 'Hearing scheduling', keywords: ['hearing', 'calendar', 'scheduling'],
  contextNeeds: ['workflowInstanceId', 'stepOccurrenceId'],
  reads: [{ code, version: 1, parameterContract: { code: code + '.parameters', version: 1 }, dataContract: { code: code + '.output', version: 1 }, parameters: { occurrenceId: 'stepOccurrenceId' } }],
  settingsSchema: { code: code + '.settings', version: 1, fields: {} },
  placements: [{ host: 'step-shell', region: 'main' }, { host: 'step-shell', region: 'supporting' }],
  layout: { widths: ['full'], minimumWidthPx: 250, minimumHeightPx: 100, responsive: 'stack-in-order' }, instances: 'single-per-workspace',
}));

/** Additive layout version: saved v1 manifests and their publication hashes stay intact. */
export const resizableSchedulingBlockManifests: readonly BlockManifest[] = originalSchedulingBlockManifests.map((manifest) => ({
  ...manifest,
  version: 2,
  layout: { ...manifest.layout, widths: ['full', 'half'] },
}));
export const schedulingBlockManifests: readonly BlockManifest[] = [
  ...originalSchedulingBlockManifests,
  ...resizableSchedulingBlockManifests,
  {
    ...resizableSchedulingBlockManifests[0], version: 3,
    description: 'Book from the calendar or choose a date using configured time and location defaults.',
    settingsSchema: { code: 'scheduling.hearing.settings', version: 2, fields: {
      bookingMode: { type: 'enum', required: true, values: ['calendar', 'inline-date'] },
      startTime: { type: 'string', required: false, maxLength: 5 },
      endTime: { type: 'string', required: false, maxLength: 5 },
      timeZoneId: { type: 'string', required: false, maxLength: 100 },
      locationName: { type: 'string', required: false, maxLength: 200 },
      roomName: { type: 'string', required: false, maxLength: 200 },
    } },
  },
];
